// removed by extract-text-webpack-plugin
module.exports = {"block":"_2oP0V_zc1KDyBLxZt9ESIz","map":"_2X52O6Yh0kn3hPva3IlTmy","call-to-action":"_2cycdbsD7AKonD6YrgGfHn","marker":"_3gu00cZeTB8bJOhHkiYK29","heading":"xWOW7mY-nS1zVBWchJbR_","projects":"_2nvpAKNkuJrnRcCfr9KKbN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MapLocationBlock/MapLocationBlock.module.scss
// module id = 787
// module chunks = 0